// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { formatValue } from 'Utils/deliverables';

// Admin-facing wording for the card-charged rule (AUT-6526): on an order whose card was charged at
// checkout the dollars are frozen at the charge — no pricing override, no repricing edit, no rate
// edit; a credit adjustment moves credits only. The server refuses the writes; these notices are the
// courtesy layer in Treasure Chest. Copy is Joel's to bless. Every notice names the charged amount
// when the order carries one.

type ChargedOrderFields = Pick<IOrder, 'chargeId' | 'paidForThisProject'>;

// chargeId is written only when a Stripe charge actually happened — the same signal the status
// dropdown uses to refuse cancellation.
export const isCardCharged = (order?: Pick<IOrder, 'chargeId'> | null) => Boolean(order?.chargeId);

const chargedClause = (order?: ChargedOrderFields | null) =>
  (typeof order?.paidForThisProject === 'number' ? ` ($${formatValue(order.paidForThisProject)} charged)` : '');

export const chargedOverrideNotice = (order?: ChargedOrderFields | null) =>
  `Not available — this order was paid by credit card at checkout${chargedClause(order)}. `
  + 'An override would change the order\'s cost without changing the charge; adjust the charge in Stripe instead.';

export const chargedEditNotice = (order?: ChargedOrderFields | null) =>
  `Paid by credit card at checkout${chargedClause(order)} — bundle, density, delivery speed, add-ons and credit rate are locked. `
  + 'Delivery date, delivery estimate, reference ID, team and buffer can still be edited.';

export const chargedAdjustmentNotice = (order?: ChargedOrderFields | null) =>
  `This order was paid by credit card${chargedClause(order)}. `
  + 'The adjustment changes credits only — the charge and the order\'s cost stay as charged.';
